import { fmtKpi } from "./kpiFormat";

const Chips = ({ title, items, kind, onOpen }) => (
  <div className="flex flex-wrap items-baseline gap-1.5" data-testid={`kpi-lead-sources-${kind}`}>
    <span className="w-20 shrink-0 text-2xs font-semibold uppercase tracking-[0.16em] text-zinc-400">{title}</span>
    {items.map((x, i) => (
      <button key={x.id || "none"} type="button" onClick={() => onOpen(x.id ? x.name : "")}
        data-testid={`kpi-lead-source-${kind}-${i}`} title="Show these leads"
        className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs transition-colors hover:border-blue-300 hover:bg-blue-50 hover:text-blue-800 ${
          x.id ? "border-zinc-200 bg-white text-zinc-700" : "border-dashed border-zinc-300 bg-transparent text-zinc-500"}`}>
        <span className="max-w-[16rem] truncate">{x.name}</span>
        <span className="font-mono-num font-semibold text-zinc-900">{x.value}</span>
      </button>
    ))}
  </div>
);

/** "Cost per lead by campaign": the week's optional spend split ÷ that campaign's Meta paid leads. */
export const CampaignCostLine = ({ r }) => {
  const s = r?.components?.campaign_split;
  return (
    <tr className="bg-zinc-50/60 align-top" data-testid="kpi-detail-row-campaign-cost">
      <td className="py-2 pr-3 pl-4 text-xs text-zinc-500">↳ cost per lead by campaign</td>
      <td className="py-2 pr-3 text-xs text-zinc-400" colSpan={2}>{s ? `${s.rows.filter((x) => x.spend != null).length} campaign(s)` : "—"}</td>
      <td className="py-2 pr-3 text-xs text-zinc-500" colSpan={2} data-testid="kpi-campaign-cost">
        {!s ? "Split this week's spend by campaign under Ad spend & data, then refresh the draft" : (
          <table className="w-full max-w-xl">
            <thead><tr className="text-left text-2xs uppercase tracking-[0.16em] text-zinc-400">
              <th className="pb-1 font-semibold">Campaign</th><th className="pb-1 font-semibold">Spend</th>
              <th className="pb-1 font-semibold">Paid leads</th><th className="pb-1 font-semibold">Cost per lead</th></tr></thead>
            <tbody>
              {s.rows.map((x, i) => (
                <tr key={x.id || `none-${i}`} className="border-t border-zinc-100" data-testid={`kpi-campaign-cost-row-${i}`}>
                  <td className="py-1 pr-3 text-zinc-700">{x.name}</td>
                  <td className="py-1 pr-3 font-mono-num">{x.spend == null ? <span className="text-zinc-400">not split</span> : fmtKpi(x.spend, "money2")}</td>
                  <td className="py-1 pr-3 font-mono-num">{x.leads}</td>
                  <td className="py-1 pr-3 font-mono-num font-semibold text-zinc-900">
                    {x.value != null ? fmtKpi(x.value, "money2") : <span className="font-normal text-zinc-400">{x.spend == null ? "—" : "N/A — no leads"}</span>}
                  </td>
                </tr>
              ))}
              {s.not_split > 0 && (
                <tr className="border-t border-zinc-100 text-zinc-500" data-testid="kpi-campaign-cost-not-split">
                  <td className="py-1 pr-3 italic">Not split to a campaign</td><td className="py-1 pr-3 font-mono-num">{fmtKpi(s.not_split, "money2")}</td>
                  <td /><td />
                </tr>
              )}
            </tbody>
          </table>
        )}
      </td>
    </tr>
  );
};

/** "Where the paid leads came from": Meta paid leads split by Facebook form and by campaign. */
export const LeadSourcesLine = ({ r, onOpen }) => {
  const c = r?.components || {};
  const missing = c.by_form === undefined;
  return (
    <tr className="bg-zinc-50/60 align-top" data-testid="kpi-detail-row-lead-sources">
      <td className="py-2 pr-3 pl-4 text-xs text-zinc-500">↳ where the paid leads came from</td>
      <td className="py-2 pr-3 text-xs text-zinc-400" colSpan={2}>{missing ? "—" : `${r.value} lead(s)`}</td>
      <td className="py-2 pr-3 text-xs text-zinc-500" colSpan={2} data-testid="kpi-lead-sources">
        {missing ? "Not in this snapshot — refresh the draft to see forms and campaigns"
          : !r.value ? "No Meta paid leads this week"
            : (
              <div className="space-y-1.5">
                <Chips title="Form" items={c.by_form} kind="form" onOpen={onOpen} />
                <Chips title="Campaign" items={c.by_campaign} kind="campaign" onOpen={onOpen} />
              </div>
            )}
      </td>
    </tr>
  );
};
